import {StorageService} from './../services/storage.service';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import {EMPTY, Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {AuthService} from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private storageService: StorageService
  ) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentClient = this.storageService.getItem('currentClient');
    const userProfile = this.storageService.getItem('profile');

    let lang: string
    switch (userProfile?.profileType) {
      case 'CIT':
        lang = 'sw';
        break;
      case 'KIOSK_AGENT':
        lang = 'en';
        break;
      default:
        if (request.body?.operationName?.toLowerCase().includes('citizen')) {
          lang = this.storageService.getItem('language') || 'sw'
        } else {
          lang = 'all';
        }
    }
    if (!request.url.includes('oauth2/access_token')) {
      if (currentClient) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentClient}`,
            lang,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': '*',
          },
        });

        if (!request.url.includes(currentClient)) {
          request = request.clone({
            url: request.url + '?access_token=' + currentClient,
          });
        }
      } else {
        let lang: string = this.storageService.getItem('language') || 'sw'

        request = request.clone({
          setHeaders: {
            lang,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': '*',
          },
        });
      }
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // console.log('events...' + event);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse | any) => {
        // @ts-ignore
        const data = {
          reason: error && error.error?.reason ? error.error?.reason : '',
          status: error?.status,
          causedBy: error.error?.error_description,
          msg: error.error?.errors
            ? error.error.errors[0].extensions.code
            : null,
        };

        // this.auth.collectFailedRequest(data);

        return EMPTY;
      })
    );

  }
}
